/**
  * @class meleSignature
  * @description
  *
  * # Purpose
  * Implements `<mele-signature>` custom web element.
  *
  * # Use
  * Create element in HTML:
  * ```
  * parentEl.innerHTML += '<mele-signature></mele-signature>';
  * ```
  * Create element in JavaScript:
  * ```
  * parentEl.appendChildren({
  *   tag: 'mele-signature',
  *   ... other attributes ...
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleElement from 'meleElement'

const PROPERTIES = _.extend({}, {
  image: { type: 'string', description: 'base64 image from signature' },
}, meleElement._properties)

export default class meleSignature extends meleElement {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * Creates internal DOM structure.
   */
  init() {
    super.init()
    this.canvas = this.appendChildren({ tag: 'canvas' })
  } // init

  showSignaturePad(cb) {
    try {
      if(mosy_plugins.SignaturePad) {
        mosy_plugins.SignaturePad.getSignature((imgData) => {
          if(!imgData) {
            cb(new Error('Posralo sa to'), '')
            return
          }

          const ctx = this.canvas.getContext('2d')
          this.canvas.width = imgData.width
          this.canvas.height = imgData.height

          ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
          ctx.putImageData(imgData, 0, 0)
          const base64 = this.canvas.toDataURL('image/jpeg', 1.0)
          cb(null, base64)
        }, (msg) => {
          console.error('Could not obtain a signature due to an error: ' + msg)
          cb(msg, '')
        },
        {
          title: '',
          htmlPage: '',
          strokeWidth: '5',
        })
      }
    } catch (e) {
      console.error(e.message, 'SignaturePad unavailable')
      // this.errorodalError(e.message, 'SignaturePad unavailable')
    }
  }
} // class meleSignature

meleSignature._properties = PROPERTIES
meleSignature.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-signature', meleSignature)
